export enum ClaimGenerationMethod {
    EncounterDate = 1,
    StatementDate = 2
}